"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        // Add queryable_field_2 as timestamptz for cron trigger next execution time
        // This allows efficient querying for due cron triggers
        table.timestamp('queryable_field_2', {
            useTz: true
        });
    });
    // Add index on queryable_field_2 for efficient time-based queries
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        table.index('queryable_field_2', 'nc_dependency_tracker_queryable_field_2_idx');
    });
};
const down = async (knex)=>{
    // Drop index first
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        table.dropIndex('queryable_field_2', 'nc_dependency_tracker_queryable_field_2_idx');
    });
    // Then drop column
    await knex.schema.alterTable(_globals.MetaTable.DEPENDENCY_TRACKER, (table)=>{
        table.dropColumn('queryable_field_2');
    });
};
